import * as React from "react";
const SvgFiRrDonut = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-donut_svg__a)">
      <path
        fill="#062147"
        d="M12 0C5.4 0 .03 5.356.003 11.949q-.001.007-.003.013l.002.008L0 12c0 6.617 5.383 12 12 12 2.108 0 4.183-.556 6-1.606a1 1 0 1 0-1.001-1.73 10 10 0 0 1-5 1.337c-5.155 0-9.409-3.921-9.942-8.937.222.071.433.175.621.322a3 3 0 0 0 1.821.615c.663 0 1.311-.219 1.821-.615.234-.182.506-.284.79-.349a5.01 5.01 0 0 0 4.889 3.964 5.01 5.01 0 0 0 4.899-4h.101c.54 0 .979.438 1 .996v4.004a1 1 0 1 0 2 0v-4.002c.02-.56.459-.998 1-.998.551 0 1 .448 1 1v7a1 1 0 1 0 2 0v-9C24 5.383 18.617 0 12 0m0 15c-1.654 0-3-1.346-3-3s1.346-3 3-3 3 1.346 3 3-1.346 3-3 3m9-4a2.95 2.95 0 0 0-1.998.78A2.96 2.96 0 0 0 17 11h-.101A5.01 5.01 0 0 0 12 7a5.01 5.01 0 0 0-4.899 3.999 3.97 3.97 0 0 0-2.007.805c-.322.251-.863.253-1.188 0a3.97 3.97 0 0 0-1.856-.793C2.548 5.96 6.82 2 12 2c5.234 0 9.534 4.045 9.958 9.171A3 3 0 0 0 21 11"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-donut_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrDonut;
